import { comparedAddressFields } from '@/DeliveryMethodsPage/constants'
import { getAddressFieldValue } from '@/DeliveryMethodsPage/helpers'

import { addressValidationErrorField, addressValidationErrorMessages } from './constants'

export const getFieldErrors = (errorCodes, t) => {
  const message = addressValidationErrorMessages[errorCodes[0]]

  if (!message) return null

  return { [addressValidationErrorField]: t(message) }
}

const getSuggestedProvince = (address, suggestion, provinces) => {
  return provinces?.find(province => province.code === suggestion.province) || address.province
}

export const getSuggestedAddress = (address, suggestion, provinces) => {
  return {
    ...address,
    line_1: suggestion.line_1,
    line_2: suggestion.line_2,
    house_number: suggestion.house_number,
    postcode: suggestion.postcode,
    locality: suggestion.locality,
    province: getSuggestedProvince(address, suggestion, provinces),
  }
}

const getComparableValue = (address, field) => {
  const value = getAddressFieldValue(address, field, 'code')

  if (!value) return ''

  return value.trim().toLowerCase()
}

export const getDifferingAddressFields = (address, suggestedAddress) => {
  return comparedAddressFields.filter(
    field => getComparableValue(address, field) !== getComparableValue(suggestedAddress, field)
  )
}
